import { render, staticRenderFns } from "./InboxTable.vue?vue&type=template&id=316d48d8&scoped=true&"
import script from "./InboxTable.vue?vue&type=script&lang=js&"
export * from "./InboxTable.vue?vue&type=script&lang=js&"
import style0 from "./InboxTable.vue?vue&type=style&index=0&id=316d48d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316d48d8",
  null
  
)

export default component.exports